// extracted by mini-css-extract-plugin
export var fullHeightState = "_5h-7";
export var headerCell = "_5h-1";
export var loadingStateCell = "_5h-4";
export var rowWrapper = "_5h-3";
export var standaloneTable = "_5h-8";
export var standaloneTableWithBodyFill = "_5h-9";
export var stateCell = "_5h-5";
export var table = "_5h-0";
export var tableBodyFiller = "_5h-6";
export var white = "_5h-2";